import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { Segment } from '../types';

type FiltersContextState = {
  overviewMetrics: string[];
  setOverviewMetrics: (overviewMetrics: string[]) => void;
  timeSeriesMetrics: string[];
  setTimeSeriesMetrics: (timeSeriesMetrics: string[]) => void;
  segment: Segment;
  setSegment: (segment: Segment) => void;
  segmentMetrics: string[];
  setSegmentMetrics: (segmentMetrics: string[]) => void;
  region: string[];
  setRegion: (region: string[]) => void;
  variantId: number | string;
  setVariantId: (variantId: number | string) => void;
  filterString: string;
  setFilterString: (val: string) => void;
};

export const initialFilterContextState = {
  overviewMetrics: [],
  setOverviewMetrics: noop,
  timeSeriesMetrics: [],
  setTimeSeriesMetrics: noop,
  segment: undefined,
  setSegment: noop,
  segmentMetrics: [],
  setSegmentMetrics: noop,
  region: ['021'],
  setRegion: noop,
  variantId: 'default',
  setVariantId: noop,
  filterString: '',
  setFilterString: noop,
};

export const FiltersContext = createContext<FiltersContextState>(initialFilterContextState);

export const useFiltersContext = () => useContext(FiltersContext);
